export default class ProductColorSwitchController {
    constructor() {
        this.containers = [];

        if (document.querySelectorAll('.productOverviewContainerController.productOverviewContainer').length) {
            this.init();
        }
    }

    init() {
        document.querySelectorAll('.productOverviewContainerController.productOverviewContainer').forEach(container => {
            this.containers.push(container);
        });

        this.setEventListeners();
    }

    setEventListeners() {
        this.containers.forEach(container => {
            const buttons = container.querySelectorAll('button[data-color-id]');

            buttons.forEach(button => {
                button.addEventListener('click', () => {
                    this.handleClick(container, button);
                });
            });
        });
    }

    handleClick(container, button) {
        // Get selected option value from button data
        const colorID = button.dataset.colorId;

        // Remove existing show class from the image
        container.querySelectorAll('.productOverviewImageContainer img').forEach(image => image.classList.remove('showProduct'));

        // Remove existing active product class from the row
        $(container).find('.row').removeClass("activeProduct");

        // Select row based on its data-color-id attribute value
        $(container).find('.row[data-color-id=' + colorID + ']').addClass("activeProduct");

        // Select image based on its data-color-id attribute value
        $(container).find('.productOverviewImageContainer img[data-color-id=' + colorID + ']').addClass("showProduct");
    }
}